import { useEffect } from 'react';
import QueryString from 'query-string';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FeatureFlags } from 'modules/featureFlags';
import { isUAECountry } from 'config/countriesEnvironments';
import config from 'config';

// Query string param that overrides the feature flag, both ways:
//   ?redirect-v2=true  -> force the redirect (test it before the rollout)
//   ?redirect-v2=false -> suppress the redirect (escape to v1 after the rollout)
//   absent             -> follow the rollout-redirect-v2 flag
const REDIRECT_PARAM = 'redirect-v2';

/**
 * Frontend-redirects users from v1 (dev portal, dev.leantech.me) to v2
 * (dashboard.leantech.me) when the rollout flag is on. UAE only — KSA builds
 * never redirect. Renders nothing.
 */
const V2RedirectGate = (): null => {
  const isRedirectFlagOn = useFeatureIsOn(
    FeatureFlags.rolloutRedirectV2 as string,
  );

  useEffect(() => {
    if (!isUAECountry) return;

    const params = QueryString.parse(window.location.search);
    const override = params[REDIRECT_PARAM];

    let shouldRedirect = isRedirectFlagOn;
    if (override === 'true') shouldRedirect = true;
    if (override === 'false') shouldRedirect = false;

    if (!shouldRedirect) return;

    // Preserve any existing query params except our own control param.
    const { [REDIRECT_PARAM]: _omit, ...rest } = params;
    const query = QueryString.stringify(rest);
    const target = `${config.v2DashboardUrl}${query ? `?${query}` : ''}`;

    window.location.replace(target);
  }, [isRedirectFlagOn]);

  return null;
};

export default V2RedirectGate;
